/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'notAdd': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M194.5 195.7c-175 174.9-175 458.6 0 633.6 175 174.9 458.7 174.9 633.7 0 175-174.9 175-458.6 0-633.6-175.1-174.9-458.8-174.9-633.7 0zm53 53C384.2 112 600.7 103.6 747.2 223.5L222.3 748.4c-119.9-146.5-111.5-363 25.2-499.7zm527.6 527.6C638.4 913 421.9 921.4 275.4 801.5l524.9-524.9c119.9 146.5 111.5 362.9-25.2 499.7z" _fill="#bfbfbf"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/notAdd.js